import { Component, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Platform } from 'ionic-angular';
import { APP_CONFIG } from '../../environment';
import { brandings } from '../../environment/branding/brandings'
import { HttpProvider } from '../../providers/http/http';
import { RouteProvider } from '../../providers/route/route';
import { ColorProvider } from '../../providers/color/color';

declare const cordova;
@Component({
  selector: 'rmt-translate',
  templateUrl: 'rmt-translate.html'
})
export class RmtTranslateComponent {
  @Input() translate: string;
  @Input() translateValues: any = {};
  @Input() translated: string;
  @Input() useModalHeader: boolean = true;
  @Input() username: string;
  @Input() underline: boolean = false;
  @Input() openInIAB: boolean = true;
  @Input() textColor: string;
  @Input() underlineTextWithLink: boolean = false;
  // false for links to fixed-width desktop pages (e.g. MEPS/FPX): the in-app browser
  // otherwise lays them out at 980px and scales them down to a third of the screen.
  @Input() iabWideViewPort: boolean = true;
  @Output() triggerEvent = new EventEmitter<string>();
  @ViewChild('container', { read: ElementRef }) container;
  parts;
  lastTranslation;
  static openInIABStatic;
  static isCordova;
  onLangChangeSubscription;
  defaultColor: string;
  constructor(private translateService: TranslateService,
              private routeProvider: RouteProvider,
              private platform: Platform,
              private iab: InAppBrowser) {
    if (this.platform.is('cordova'))
      RmtTranslateComponent.isCordova = true;
  }
  
  ngAfterViewInit() {
    this.defaultColor = APP_CONFIG.branding === brandings.Walmart ? '#0084ff' : ColorProvider.getColorValue('--app-primary');
    this.textColor = this.textColor ? this.textColor : this.defaultColor;

    RmtTranslateComponent.openInIABStatic = this.openInIAB;
    if (this.translate) {
      const translated = this.translateService.instant(this.translate, this.translateValues);    
      if (translated)
        this.parseTranslated(translated);
    }
    else if (this.translated)
      this.parseTranslated(this.translated);
  }
  /* TODO: enhance  
     added because wallet-not-active page will not be refreshed when the language is updated . 
     used translateService provider as its already used here  */
  ngOnInit() {
    this.onLangChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.ngAfterViewInit();
    });
  }
  ngOnDestroy() {
    this.onLangChangeSubscription.unsubscribe();
  }
  ngOnChanges() {
    let translated = null;
    if (this.translate)
      translated = this.translateService.instant(this.translate, this.translateValues);
    else if (this.translated)
      translated = this.translated;

    if (translated && translated !== this.lastTranslation)
      this.parseTranslated(translated);
  }

  parseTranslated(translated) {
    this.lastTranslation = translated;
    
    const parts = translated.split('|');
    this.parts = []
    let expression = false;
    for (let i=0; i < parts.length; i++) {
      const current = parts[i];
      const part = {
        text: current,
        link: null
      }
      if (expression && current) {
        const subparts = current.split(',=');
        if (subparts.length === 2) {
          part.text = subparts[0].trim();
          part.link = subparts[1].trim();
        }
      }
      expression = !expression;
      this.parts.push(part);      

      // if there any links hidden in the translated content modify them to use openModal instead of opening in the same window
      window.requestAnimationFrame(() => {
        const parts = this.container.nativeElement.getElementsByClassName('part');
        if (!parts)
          return;
        RmtTranslateComponent.parseLinks(parts, this.routeProvider, this.useModalHeader, this.username, this.defaultColor, this.textColor, this.underlineTextWithLink, this.triggerEvent, this.iabWideViewPort);
      });
    }
  }

  static parseLinks(parts, routeProvider, useModalHeader, username = null,defaultColor = '', textColor = '', underlineTextWithLink: boolean = false, triggerEvent: EventEmitter<string> = null, iabWideViewPort: boolean = true) {
    
    for (let i=0; i < parts.length; i++) {
      const part = parts[i];
      const links = part.getElementsByTagName('a');
      if (links) {
        for (let l=0; l < links.length; l++) {
          const link = links[l];
          link.style.position = 'relative'; // important otherwise the textnodes could prevent the link from being clickable
          link.style.color = textColor;
          if(underlineTextWithLink) {
            link.style.textDecoration = "underline"; 
          }
          link.onclick = (ev) => {
            ev.stopPropagation();
            ev.preventDefault();
            if (triggerEvent)
              triggerEvent.emit(link.href);
            if (link.href && link.href.trim().indexOf('tel:') === 0)
            window.location.href = link.href;
            else if (link.href && link.href.trim().indexOf('mailto:') === 0){
              if (RmtTranslateComponent.isCordova)
                cordova.InAppBrowser.open(link.href, '_system');
              else
                window.location.href = link.href;
            }
            else if (RmtTranslateComponent.openInIABStatic && RmtTranslateComponent.isCordova) {
              const toolBarColor = ColorProvider.getColorValue('--gray-100');
              const viewPort = iabWideViewPort ? '' : ',useWideViewPort=no';
              cordova.InAppBrowser.open(link.href, '_default',`location=no,toolbartranslucent=no,hidenavigationbuttons=yes,toolbarcolor=${toolBarColor},hideurlbar=yes,toolbarposition=top,closebuttoncaption=X,closebuttoncolor=${defaultColor}${viewPort}`);
              return;
            }
            else {
              // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! TEMPORARY
              if (link.href && APP_CONFIG.region.defaultCountryFrom === 'SG') {
                const lang = RmtTranslateComponent.getRedirectLanguage();
                link.href = link.href.replace('app.riamoneytransfer.com/app-terms-and-conditions', 'app.riamoneytransfer.com/' + lang + '/app-terms-and-conditions');
                link.href = link.href.replace('app.riamoneytransfer.com/app-privacy-policy', 'app.riamoneytransfer.com/' + lang + '/app-privacy-policy');
              }
              if (RmtTranslateComponent.openInIABStatic && RmtTranslateComponent.isCordova) {
                const toolBarColor = ColorProvider.getColorValue('--gray-100');
                cordova.InAppBrowser.open(link.href, '_default',`location=no,toolbartranslucent=no,hidenavigationbuttons=yes,toolbarcolor=${toolBarColor},hideurlbar= yes,toolbarposition=top,closebuttoncaption=X,closebuttoncolor=${defaultColor}`);
                return;
              }
              else {
                if (username && link.href && link.href.endsWith('/support-code'))
                  link.href += '/' + username;

                let header = null;
                if (useModalHeader)
                  header = link.innerText
                routeProvider.openModal(routeProvider.pages.HrefPage, { header: header, href: link.href });
              }
            }
          }
        }
      }
    }
  }

  static getRedirectLanguage() {
    const defaultLang = 'en-' + APP_CONFIG.region.defaultCountryFrom;
    let lang = HttpProvider.currentLanguage;
    if (!lang)
      lang = defaultLang;

    const langs = APP_CONFIG.region.languageCultures;
    const language = langs.find(language => { return language.indexOf(lang.substr(0, 2).toLowerCase()) === 0});
    // Public site is case-sensitive on the locale path segment and only resolves lowercase locales,
    // so force the whole locale (incl. the uppercase region from defaultCountryFrom) to lowercase (OM-19681).
    const redirectLang = language ? language.substr(0, 2).toLowerCase() + '-' + APP_CONFIG.region.defaultCountryFrom : defaultLang;
    return redirectLang.toLowerCase();
  }
}


// WEBPACK FOOTER //
// ./src/components/rmt-translate/rmt-translate.ts